<template>
  <div>
    <div class="el-card mt-24 p-16">
      <div class="fx">
        <!-- <div class="fx-full"></div> -->
        <el-cascader v-model="areaValue" ref="areaDropdown" class="fx-none mr-16" placeholder="地区" :options="areaOptions" filterable :props="{checkStrictly: true,children:'childOption'}"
          @change="areaChange"></el-cascader>

        <TreeDropdown v-model="industryValue" placeholder="请选择产业链节点" multiple collapseTags showCheckbox checkStrictly nodeKey="nodeCode" :data="industryChain" :defaultProps="industryProps"
          @change="industryChange" />
      </div>
      <div class="fx-wrap mt-16">
        <!-- hand :is-select="item.selected" -->
        <CompanyClassify v-for="(item,i) in classifyOptions" :key="i" :data="item" style="max-width:400px;" @click.native="clickHandle(item)" />
      </div>
    </div>

    <div class="el-card mt-24 p-16" v-loading="loading2">
      <MyTitle class="mb-16">
        产业地图
      </MyTitle>
      <div class="fx">
        <div style="width: 60%;height:600px;">
          <MyEcharts ref="chartFirst" style="width: 100%;height:600px;" />
        </div>
        <div style="width: 40%;height:600px;">
          <div>产品分布</div>
          <MyEcharts class="mt-16" ref="chartFirst2" style="width: 100%;height:256px;" />
          <div class="mt-16">区域排行</div>
          <el-scrollbar class="mt-8" style="height: 260px;">
            <div v-for="(item,i) in regionalRank" :key="i" class="fx fx-s-center mt-8  mr-16">
              <div class="fx-none index" :class="item.class">{{i+1}}</div>
              <textOverflow class="fx-none name">{{item.name}}</textOverflow>
              <div class="fx-full">
                <el-progress :percentage="item.percentage" :format="_=>item.count" :stroke-width="8" color="#186bfc"></el-progress>
              </div>
            </div>
            <emptyBox v-if="!regionalRank.length" />
          </el-scrollbar>
        </div>
      </div>
    </div>

    <div class="el-card mt-24 p-16" v-loading='waiting'>
      <MyTitle class="mb-16">
        企业名单
      </MyTitle>
      <SearchHeadChain ref="searchHead" @setCondition="setCondition" />

      <CompanyCardList ref="cardList" :resetUnlockS="isUnlock" :companyType="4" class="mt-32" :batchActions="batchActions" :list="list" element-loading-text="耐心等待小T为您大数据计算中…"
        element-loading-spinner="el-icon-loading" @isUnlock-Change="isUnlockChange" @handle-page-num="handlePageNum" @handle-page="handlePage">
        <div class="searchBar">
          <span class="font-15-md">小T为您找到 <span class="blueColor" style="color: #5088FF;">{{_totalElements}}</span> 企业商机资源</span>
        </div>
        <template v-slot:beforeBatch>
          <el-button class="gbBatchBtn" :loading="actionLoading" plain size="small" v-interestExpire @click="batchUnlockFnbefore">解锁前500</el-button>
        </template>
      </CompanyCardList>
      <UnlockDialogBatch :show.sync="unlockDialogShowBatch" :maxTotal="list.total" title="批量解锁" :confirmPromise="contactsNumBatchConfirmBatch" />
      <!-- 批量解锁提示 -->
      <BatchUnlockTip ref="batchUnlockTip" />
    </div>

  </div>
</template>

<script>
import CompanyClassify from '@/views/industryChainNew/components/companyClassify'
import CompanyCardList from '@/views/clue/components/companyCardList'
import UnlockDialogBatch from '@/views/clue/components/unlockDialogBatch'
import BatchUnlockTip from '@/components/batchUnlockTip'


import TreeDropdown from '@/components/treeDropdown/treeDropdown.vue'
import MyTitle from '../components/myTitle.vue'
import MyEcharts from '@/components/myEcharts'
import SearchHeadChain from '@/views/industryChainNew/components/searchHeadChain'
import { treeMap } from '../components/echartsOptions'
import stat from '@/views/industryChainNew/markData/stat'
import { mapState } from 'vuex'
import { searchByConditionUnlock } from '@/views/clue/api/index'
import { getGeoJson } from '@/api/asyncRouterApi'
import { getChainTopCompany, getDistribution, getIndustryChain } from '@/views/industryChainNew/api'
import { searchByCondition } from '@/views/clue/api'

export default {
  name: 'IndustryDistribution',
  components: {
    TreeDropdown,
    CompanyClassify,
    MyTitle,
    MyEcharts,
    SearchHeadChain,
    CompanyCardList,
    UnlockDialogBatch,
    BatchUnlockTip
  },
  provide() {
    return {
      unlockSourceType: 12
    }
  },
  props: {

  },
  data() {
    return {
      industryValue: [],
      industryChain: [],
      industryProps: {
        label: 'nodeName',
        disabled: function (data) {
          return !data.indirectSamNodeArray && !data.directSamNodeArray
        }
      },
      value: '',
      searchType: '5',

      companyType: '',
      classifyOptions: [
      ],
      regionalRank: [],
      areaValue: ['100000'],

      // 复制组件的参数
      loading: false,
      isUnlock: false,
      unlockDialogShowBatch: false,
      condition: {},
      list: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
        tab: 1,
        tableData: []
      },
      companyList: [],
      actionLoading: false,
      waiting: false,
      loading2: false,
      allTotal: 0
    }
  },
  computed: {
    ...mapState({
      surplus: state => state.user.surplus,
      staffInfo: state => state.user.staffInfo,
      selectArea: state => state.asyncRoute.selectArea,
    }),
    batchActions() {
      return this.surplus < 1 ? [false, true, false] : [true, true, false]
    },
    _totalElements() {
      if (this.allTotal < 100) return this.allTotal
      if (this.allTotal < 200000) return `${this.allTotal.toString().split('').reduce((res, v) => res ? res + 0 : v, '')}+`
      return '200000+'
    },
    ID() {
      return this.$route?.query?.id
    },
    areaOptions() {
      return [
        {
          label: "全国",
          value: '100000',
        },
        ...this.selectArea
      ]
    }
  },
  async mounted() {
    this.geoJsonMap = {}
    this.currentMap = ''
    this.initPage()
    this.getIndustryChain()
  },
  methods: {
    async getIndustryChain() {
      const [err, res] = await this.$reqFn(getIndustryChain, {
        "isPart": 0,
        "productNodeCode": "",
        secId: this.ID
      })
      if (res && res.code === 200) {
        const { upStreams, middleStreams, downStreams } = res.data || {}
        this.industryChain = [...(upStreams || []), ...(middleStreams || []), ...(downStreams || [])]
      }
    },
    // 批量解锁前500
    batchUnlockFnbefore() {
      // 重新获取解锁数据
      this.$store.commit('SET_FREQUENCY', this.$store.state.user.frequency + 1)
      this.unlockDialogShowBatch = true
    },
    async getChainTopCompany() {
      const [province, city, district] = await this.getCityParams()
      const [err, res] = await this.$reqFn(getChainTopCompany, {
        province, city, district,
        secId: this.ID
      })
      if (res && res.code === 200) {
        const list = res.data?.list || []
        // 	企业类型 :
        const types = {
          '上市企业': 'listed',
          '新三板企业': 'neeq',
          '发债企业': 'bond',
          '私募融资企业': 'pevc',
          '资质认定企业': 'qual',
        }
        this.classifyOptions = [
          {
            name: "全部企业",
            count: list.reduce((p, v) => (p += v.count, p), 0),
            pic: 'company1',
            selected: true,
            type: ''
          },
          ...list.map(e => ({ ...e, selected: false, type: types[e.name] }))
        ]
      }
    },
    async areaChange() {
      this.initPage()
    },
    industryChange() {
      this.initPage()
    },

    initPage() {
      // 企业分类
      this.getChainTopCompany()
      this.getResult()
    },

    async getResult() {
      // 地图数据
      // 北京 上海 重庆 天津  的中间一层4位code的要改一下，其他的不用改
      const codeList = {
        1101: 1100,
        1201: 1200,
        3101: 3100,
        5001: 5000,
      }
      let areaCode = this.areaValue[this.areaValue.length - 1]
      areaCode = codeList[areaCode] ? codeList[areaCode] : areaCode
      await this.getGeoJson(areaCode)
      // 地图
      this.initMap()
      // 分布、排行
      this.getRegionalRank()

      this.$refs.searchHead.expand = true
      this.searchByCondition()
    },

    async getGeoJson(code) {
      if (this.geoJsonMap[code]) return this.currentMap = this.geoJsonMap[code]
      const formData = new FormData()
      formData.append("code", code)
      const [err, res] = await this.$reqFn(getGeoJson, formData)
      if (err) {
        console.log(err)
      }
      if (res && res.code === 200) {
        if (!res.data) {
          this.currentMap = null
          return this.$refs.chartFirst.setEmpty()
        }
        this.geoJsonMap[code] = res.data
        this.currentMap = this.geoJsonMap[code]
      }
    },

    async getCityParams() {
      if (this.areaValue[0] === '100000') return []
      await this.$nextTick()
      const inputValue = this.$refs.areaDropdown.inputValue
      const [province, city, district] = inputValue.split(' ')
      if (province === '全国') {
        return []
      }
      return [province, city, district]
    },
    getProductNodeCodes() {
      const productNodeCodes = []
      this.industryValue.forEach(e => {
        const directSamNodeArray = e.directSamNodeArray && JSON.parse(e.directSamNodeArray) || []
        const indirectSamNodeArray = e.indirectSamNodeArray && JSON.parse(e.indirectSamNodeArray) || []
        const arr = [...directSamNodeArray, ...indirectSamNodeArray]
        arr.forEach(ee => productNodeCodes.push(ee))
      })
      return productNodeCodes

    },

    async getRegionalRank() {
      const [province, city, district] = await this.getCityParams()

      const params = {
        province,
        city,
        district,
        secId: this.ID,
        type: this.companyType
      }

      const [err, res] = await this.$reqFn(getDistribution, params, 'loading2')
      if (err) {
        console.log(err)
      }
      if (res && res.code === 200) {
        // TODO 去掉mark
        const regionStat = res.data?.regionStat // || stat.regionStat
        const productStat = res.data?.productStat // || stat.productStat

        // 区域排行
        this.regionalRank = regionStat.map((e, i) => {
          return { ...e, percentage: e.count / regionStat[0].count * 100, class: ['first', 'second', 'third'][i] }
        })

        // 产品分布
        if (productStat?.length) {
          this.$refs.chartFirst2.update(treeMap(productStat))
        } else {
          this.$refs.chartFirst2.setEmpty()
        }

        if (regionStat) {
          this.initMap(regionStat)
        }
      }
    },
    clickHandle(item) {
      return
      this.classifyOptions.forEach(e => e.selected = false)
      item.selected = true
      this.companyType = item.type
      this.getResult()
    },
    goTop() {
      this.$refs.cardList?.$el?.querySelector('.cardTitle')?.scrollIntoView?.({ block: 'start', behavior: 'smooth' })
    },
    // 过滤解锁
    isUnlockChange(val) {
      this.isUnlock = val
      // this.goTop()
      this.searchByConditionFn()
    },
    handlePage(val) {
      this.list.pageNum = val
      this.goTop()
      this.searchByConditionFn()
    },
    handlePageNum(val) {
      this.list.pageNum = 1
      this.list.pageSize = val
      this.goTop()
      this.searchByConditionFn()
    },
    async contactsNumBatchConfirmBatch() {
      try {
        const params = await this.getReqParams()
        params.source = 12;
        const { data, code } = await searchByConditionUnlock(params)
        if (code === 200) {
          if (this.staffInfo.demonstrationTag != 1) {
            this.$message.warning('批量解锁中，所需时长5分钟，请稍后在解锁列表中查看')
          }
          this.searchByConditionFn()
          this.$refs.batchUnlockTip.getUnlockBatchTip()
          this.$refs.batchUnlockTip.tipTitleF('2')
        }
      } catch (error) {
      }
    },

    async initMap(regionStat) {
      if (!this.currentMap) return
      const counts = regionStat?.map(e => e.count) || []
      const max = counts.length ? Math.max(...counts) : 100
      this.$refs.chartFirst.update({
        title: {
          show: false
        },
        tooltip: {
          trigger: 'item',
          formatter: function (p) {
            let dom = `
              <div>
                <div>${p.name}</div>
                <div class="fx" style="justify-content: space-around;">
                  <div>企业数量：</div>
                  <div class="ml-16">${p.value || 0}家</div>
                </div>
              </div>
            `
            return dom
          }
        },
        visualMap: {
          show: !!max,
          min: 0,
          max,
          text: ['高', '低'],
          realtime: false,
          calculable: true,
          inRange: {
            color: ['rgb(234,241,254)', 'rgb(41,108,225)', 'rgb(22,60,125)']
          }
        },
        series: [
          {
            roam: true,
            // name: '香港18区人口密度',
            type: 'map',
            map: 'HK',
            label: {
              show: true,
              position: 'insideTop',
              textBorderColor: '#fff',
              textBorderWidth: 2
            },
            itemStyle: {
              borderColor: 'rgb(218,227,241)',
              areaColor: '#fff',
              borderWidth: 2
            },
            data: regionStat?.map(e => ({ ...e, value: e.count })) || [],
          }
        ]
      }, { name: 'HK', geoJson: this.currentMap })
    },

    // getTreeMap() {
    //   this.$refs.chartFirst2.update(treeMap(stat.productStat))
    // },


    // 搜索无参数、筛选有参数
    setCondition(val) {
      this.searchFlag = true
      this.list.pageNum = 1
      if (val && JSON.stringify(val) !== '{}') {
        this.condition = val
        this.searchByCondition()
      } else {
        this.condition = {}
        this.searchByCondition()
      }
    },
    searchByCondition() {
      this.timer && clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.$nextTick(() => {
          this.searchByConditionFn()
        })
      }, 300)
    },
    async getReqParams() {
      const [province, city, district] = await this.getCityParams()
      const productNodeCodes = this.getProductNodeCodes()
      const isUnlockN = this.isUnlock ? 1 : 0
      return {
        // [this.$route.query.field || this.filterValue]: this.$route.query.word,
        pageNum: this.list.pageNum,
        pageSize: this.list.pageSize,
        sortType: this.sortType,
        ...this.condition,
        province, city, district,
        secId: this.ID,
        isUnLock: parseInt(isUnlockN),
        productNodeCodes
      }
    },
    async searchByConditionFn() {
      this.waiting = true
      // this.clearAllData()
      const params = await this.getReqParams()
      const res = await searchByCondition(params)
      this.waiting = false
      if (res.data) {
        const { total = 0, items = [] } = res.data
        this.allTotal = total
        this.list.total = total > 15000 ? 15000 : total
        this.list.tableData = items
      }
    }


  },
}
</script>

<style scoped lang="scss">
.index {
  width: 24px;
  height: 24px;
  text-align: center;
  border-radius: 4px;
  line-height: 24px;
  margin-right: 8px;
  &.first {
    background: linear-gradient(225deg, #fecf0f, #fd9400);
    color: #fff;
  }
  &.second {
    background: linear-gradient(225deg, #d9e4ef, #8e9fb0);
    color: #fff;
  }
  &.third {
    background: linear-gradient(225deg, #e7cab2, #b78f6d);
    color: #fff;
  }
}
.name {
  width: 60px;
}

::v-deep {
  .el-progress-bar {
    padding-right: 80px;
    margin-right: -80px;
  }
}

::v-deep .el-table-emptyImg .empty {
  margin-top: 30px;
  margin-bottom: 20px;
}
</style>
